import {setCookie} from 'cookie-utils';
import {getDomain} from 'shared/domainUtils';

import * as HistoryBetActions from 'actions/HistoryBet';
import * as CouponRateActions from 'actions/CouponRate';

export default () => next => (reducer, initialState) => {
    const store = next(reducer, initialState);

    return {
        ...store,
        dispatch(action) {
            store.dispatch(action);

            const state = store.getState();

            const languageId = state.application.get('languageId');
            const domain = state.domain;

            setCookie('languageId', languageId, getDomain(domain));

            const user = state.auth.get('user');
            if (!user) {
                return action;
            }

            const gamblerId = user.get('gamblerId');

            let betHistory = state.application.get('betHistory');

            if (betHistory !== undefined && betHistory.size > 0) {
                const keys = betHistory.keySeq().toArray();
                for (let i = 0; i < keys.length; i++) {
                    const noCashout = betHistory.get(keys[i]).delete('cashout');
                    betHistory = betHistory.updateIn(keys[i], () => noCashout);
                }
                localStorage.setItem(gamblerId + '_betHistory', JSON.stringify(betHistory.toJS()));
            }

            switch (action.type) {
                case HistoryBetActions.REMOVE_HISTORY_BET:
                    if (betHistory.size === 0) {
                        localStorage.removeItem(gamblerId + '_betHistory');
                    }
                    break;
                case HistoryBetActions.REMOVE_HISTORY_BETS:
                    localStorage.removeItem(gamblerId + '_betHistory');
                    break;
            }

            const bettingMode = state.application.get('bettingMode');
            if (bettingMode !== undefined && bettingMode.size > 0) {
                const withoutOneClick = bettingMode.delete('isOneClick');
                localStorage.setItem(gamblerId + '_bettingMode', JSON.stringify(withoutOneClick.toJS()));
            }

            let userGridStorable = state.application.get('userGridStorable');
            if (userGridStorable) {
                let userSelections = state.application.get('userGridSelection');
                if (userSelections !== undefined && userSelections.size > 0) {
                    let mainNotEmpty = (userSelections.getIn(['main', 'sportsExpanded']).size > 0);
                    let preMatchNotEmpty = (
                        userSelections.getIn(['preMatch', 'sportsExpanded']).size > 0 ||
                        userSelections.getIn(['preMatch', 'leaguesExpanded']).size > 0 ||
                        userSelections.getIn(['preMatch', 'matchesExpanded']).size > 0
                    );
                    let liveNotEmpty = (
                        userSelections.getIn(['live', 'sportsExpanded']).size > 0 ||
                        userSelections.getIn(['live', 'leaguesExpanded']).size > 0 ||
                        userSelections.getIn(['live', 'matchesExpanded']).size > 0
                    );

                    if (mainNotEmpty || preMatchNotEmpty || liveNotEmpty) {
                        localStorage.setItem(gamblerId + '_userSelections', JSON.stringify(userSelections.toJS()));
                    }
                }
            }

            const betSlips = state.application.getIn(['coupon', 'betSlips']);
            const betTypes = state.application.getIn(['coupon', 'betTypes']);
            const currentBetTypeIndex = state.application.getIn(['coupon', 'currentBetTypeIndex']);
            const couponState = state.application.getIn(['coupon', 'state']);
            const betSlipAmounts = state.application.getIn(['coupon', 'betSlipAmounts']);

            if ((betSlips !== undefined && betSlips.size > 0) &&
                (betTypes !== undefined && betTypes.size > 0) &&
                (betSlipAmounts !== undefined && betSlipAmounts.size > 0) &&
                (currentBetTypeIndex !== undefined && couponState !== undefined)) {
                localStorage.setItem(gamblerId + '_betSlips', JSON.stringify(betSlips.toJS()));
                localStorage.setItem(gamblerId + '_betTypes', JSON.stringify(betTypes.toJS()));
                localStorage.setItem(gamblerId + '_betSlipAmounts', JSON.stringify(betSlipAmounts.toJS()));
                localStorage.setItem(gamblerId + '_betTypeIndex', currentBetTypeIndex);
                localStorage.setItem(gamblerId + '_couponState', couponState);
            }

            switch (action.type) {
                case CouponRateActions.REMOVE_COUPON_RATE:
                    if (betSlips.size === 0) {
                        localStorage.removeItem(gamblerId + '_betSlips');
                        localStorage.removeItem(gamblerId + '_betTypes');
                        localStorage.removeItem(gamblerId + '_betSlipAmounts');
                        localStorage.removeItem(gamblerId + '_betTypeIndex');
                        localStorage.removeItem(gamblerId + '_couponState');
                    }
                    break;

                case CouponRateActions.REMOVE_COUPON_RATES:
                    localStorage.removeItem(gamblerId + '_betSlips');
                    localStorage.removeItem(gamblerId + '_betTypes');
                    localStorage.removeItem(gamblerId + '_betSlipAmounts');
                    localStorage.removeItem(gamblerId + '_betTypeIndex');
                    localStorage.removeItem(gamblerId + '_couponState');
                    break;
            }

            return action;
        }
    };
};



// WEBPACK FOOTER //
// ./js/sport-betting/storeInitialState.js